import React from 'react';
import { FileTextIcon, BarChart3Icon, UsersIcon, SearchIcon, MapPinIcon, CalendarIcon, ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
export const STREETLIGHT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/9fe1dc4a-bfd3-43cb-a93e-6fddec10fca8.jpg';
const BCITI_LOGO = 'https://cdn.magicpatterns.com/uploads/kFQruRR3oauw7NNUdgFajn/Logo_BCITI_(5).png';
const ATNA_LOGO = 'https://cdn.magicpatterns.com/uploads/d6cqpG2SGUofNqC1hEedXv/Logo_ATNA_(5).png';
type Status = 'processing' | 'new' | 'resolved';
type Row = {
  id: string;
  title: {
    fr: string;
    en: string;
  };
  status: Status;
  high: boolean;
  team: {
    fr: string;
    en: string;
  };
  update?: {
    fr: [string, string];
    en: [string, string];
  };
};
const ROWS: Row[] = [{
  id: '#25473',
  title: {
    fr: 'Lampadaire rue des Érables',
    en: 'Streetlight on rue des Érables'
  },
  status: 'processing',
  high: false,
  team: {
    fr: 'Travaux publics',
    en: 'Public works'
  },
  update: {
    fr: ['Aujourd’hui', '10 h 24'],
    en: ['Today', '10:24 AM']
  }
}, {
  id: '#25472',
  title: {
    fr: 'Nids-de-poule – Maple',
    en: 'Potholes – Maple'
  },
  status: 'new',
  high: true,
  team: {
    fr: 'Voirie',
    en: 'Roads'
  },
  update: {
    fr: ['Aujourd’hui', '9 h 12'],
    en: ['Today', '9:12 AM']
  }
}, {
  id: '#25471',
  title: {
    fr: 'Collecte manquée',
    en: 'Missed waste collection'
  },
  status: 'processing',
  high: false,
  team: {
    fr: 'Environnement',
    en: 'Environment'
  },
  update: {
    fr: ['Aujourd’hui', '8 h 45'],
    en: ['Today', '8:45 AM']
  }
}, {
  id: '#25470',
  title: {
    fr: 'Parc – équipement',
    en: 'Park – equipment'
  },
  status: 'resolved',
  high: false,
  team: {
    fr: 'Loisirs',
    en: 'Recreation'
  }
}];
const STATUS_LABEL: Record<Status, {
  fr: string;
  en: string;
}> = {
  processing: {
    fr: 'En traitement',
    en: 'In progress'
  },
  new: {
    fr: 'Nouvelle',
    en: 'New'
  },
  resolved: {
    fr: 'Résolue',
    en: 'Resolved'
  }
};
export function RequestsDashboardMock({
  isFR
}: {
  isFR: boolean;
}) {
  const t = (fr: string, en: string) => isFR ? fr : en;
  const filters = isFR ? ['Toutes', 'Nouvelles', 'En traitement', 'Résolues'] : ['All', 'New', 'In progress', 'Resolved'];
  return <div className="rounded-[22px] border-[6px] border-[#1C1D24] bg-white shadow-[0_30px_80px_-30px_rgba(40,36,120,0.25)] overflow-hidden" aria-label={t('Interface d’administration Requêtes ATNA', 'ATNA Requests admin interface')} data-id="element-6271" data-mp="2lhrszv8zs604">
      {/* App nav */}
      <div className="flex items-center gap-6 px-6 border-b border-[#EEF0F4] h-[52px]" data-id="element-6272" data-mp="3i7ivohrfszh0">
        <span className="flex items-center gap-1.5 shrink-0" data-id="element-6273" data-mp="347hv73f33u22">
          <img src={BCITI_LOGO} alt="BCITI" className="h-[28px] w-auto object-contain" data-id="element-6274" data-mp="346ydnntcj7ok" />
          <span className="w-px h-3.5 bg-[#C9CCD6]" aria-hidden="true" data-id="element-6275" data-mp="394riacf03tmq" />
          <img src={ATNA_LOGO} alt="ATNA" className="h-[24px] w-auto object-contain" data-id="element-6276" data-mp="1srt4q22mgcwi" />
        </span>
        <nav className="flex items-stretch h-full gap-5 font-sans text-[11px] text-[#7A8194]" data-id="element-6277" data-mp="1xs75cz1w8kki">
          <span className="flex items-center gap-1.5 text-[#4F46E5] border-b-2 border-[#4F46E5] px-2" data-id="element-6278" data-mp="1p9dj927k5t0c">
            <FileTextIcon className="w-3.5 h-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-6279" data-mp="1l7ibbev4ghdl" />
            {t('Requêtes', 'Requests')}
          </span>
          <span className="hidden sm:flex items-center gap-1.5" data-id="element-6280" data-mp="1z68g7go6nlci">
            <BarChart3Icon className="w-3.5 h-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-6281" data-mp="1uajfvb4ca0f5" />
            {t('Analytique', 'Analytics')}
          </span>
          <span className="hidden sm:flex items-center gap-1.5" data-id="element-6282" data-mp="11kkova6l3t7u">
            <UsersIcon className="w-3.5 h-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-6283" data-mp="11mdviph76dfu" />
            {t('Équipes', 'Teams')}
          </span>
        </nav>
      </div>

      <div className="px-6 pt-6" data-id="element-6284" data-mp="1bigszi13tnwg">
        {/* Title row */}
        <div className="flex flex-wrap items-start justify-between gap-3" data-id="element-6285" data-mp="1bgxhe4qe8110">
          <div data-id="element-6286" data-mp="nrbizjhuhpu2">
            <p className="font-serif text-[22px] text-[#121212] leading-none" data-id="element-6287" data-mp="nqtczv5drx8y">{t('Requêtes', 'Requests')}</p>
            <p className="font-sans text-[10.5px] text-[#7A8194] mt-2" data-id="element-6288" data-mp="3i82dx7hpr61w">
              {t('Suivi et gestion de toutes les demandes citoyennes', 'Tracking and management of every resident request')}
            </p>
          </div>
          <div className="flex items-center gap-2 font-sans text-[10.5px] text-[#121212]" data-id="element-6289" data-mp="3r8icc2jlnmzw">
            <span className="flex items-center gap-1.5 rounded-lg border border-[#E8E9EE] px-3 py-1.5" data-id="element-6290" data-mp="3w00h71oqu7q5">
              <MapPinIcon className="w-3 h-3 text-[#5B6478]" strokeWidth={1.8} aria-hidden="true" data-id="element-6291" data-mp="4tz0aci3kjwl" />
              Brossard
              <ChevronDownIcon className="w-3 h-3 text-[#9AA0AE]" aria-hidden="true" data-id="element-6292" data-mp="9qz3mfnkb8k0" />
            </span>
            <span className="hidden sm:flex items-center gap-1.5 rounded-lg border border-[#E8E9EE] px-3 py-1.5" data-id="element-6293" data-mp="erv9gyrh54s2">
              <CalendarIcon className="w-3 h-3 text-[#5B6478]" strokeWidth={1.8} aria-hidden="true" data-id="element-6294" data-mp="is5muwhlixgy" />
              {t('Été 2026', 'Summer 2026')}
              <ChevronDownIcon className="w-3 h-3 text-[#9AA0AE]" aria-hidden="true" data-id="element-6295" data-mp="2kjs96kqjm473" />
            </span>
            <span className="w-7 h-7 rounded-full bg-[#EEF0FF] text-[#4F46E5] text-[9.5px] font-semibold flex items-center justify-center" data-id="element-6296" data-mp="2d12gy5zv4pv0">
              ML
            </span>
          </div>
        </div>

        {/* Search */}
        <div className="mt-5 flex items-center gap-2 rounded-lg border border-[#E8E9EE] px-3 py-2 font-sans text-[10.5px] text-[#9AA0AE]" data-id="element-6297" data-mp="23bixoz88mtzm">
          <SearchIcon className="w-3.5 h-3.5" strokeWidth={1.8} aria-hidden="true" data-id="element-6298" data-mp="2vzoitn37ekzz" />
          {t('Rechercher une demande, un lieu, un numéro…', 'Search for a request, a place, a number…')}
        </div>

        {/* Filters */}
        <div className="mt-3.5 flex items-center justify-between gap-2" data-id="element-6299" data-mp="2my770gwtx5h3">
          <div className="flex flex-wrap gap-1.5 font-sans text-[10.5px]" data-id="element-6300" data-mp="2hzvw02ussoxa">
            {filters.map((f, i) => <span key={f} className={i === 0 ? 'rounded-full bg-[#EEF0FF] text-[#4F46E5] px-3 py-1' : 'rounded-full border border-[#E8E9EE] text-[#5B6478] px-3 py-1'} data-id="element-6301" data-mp="1bkcu28tb6e5l" data-mpi={i}>
                {f}
              </span>)}
          </div>
          <span className="hidden md:flex items-center gap-1.5 rounded-lg border border-[#E8E9EE] px-3 py-1 font-sans text-[10.5px] text-[#121212]" data-id="element-6302" data-mp="1cywa4ck8n3hn">
            {t('Plus de filtres', 'More filters')}
            <ChevronDownIcon className="w-3 h-3 text-[#9AA0AE]" aria-hidden="true" data-id="element-6303" data-mp="134vwfmaw4pxb" />
          </span>
        </div>

        {/* Table */}
        <div className="mt-4 font-sans" data-id="element-6304" data-mp="u2ms5e67tssd">
          <div className="grid grid-cols-[16px_minmax(0,2.3fr)_minmax(0,1.2fr)_minmax(0,1fr)] sm:grid-cols-[16px_minmax(0,2.3fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1.2fr)_minmax(0,1fr)] gap-3 px-1 pb-2 text-[8.5px] font-semibold tracking-[0.08em] uppercase text-[#7A8194]" data-id="element-6305" data-mp="u3pi9jvprr78">
            <span data-id="element-6306" data-mp="6dlftfu9hxht" />
            <span data-id="element-6307" data-mp="6dbx8dbjqsm5">{t('Demande', 'Request')}</span>
            <span data-id="element-6308" data-mp="bc4zf9ldux70">{t('Statut', 'Status')}</span>
            <span data-id="element-6309" data-mp="batwfbzrhtgy">{t('Priorité', 'Priority')}</span>
            <span className="hidden sm:block" data-id="element-6310" data-mp="3nupjohoj821s">{t('Équipe', 'Team')}</span>
            <span className="hidden sm:block" data-id="element-6311" data-mp="3nx29fh0j7gpe">{t('Mise à jour', 'Updated')}</span>
          </div>
          {ROWS.map(r => <div key={r.id} className="grid grid-cols-[16px_minmax(0,2.3fr)_minmax(0,1.2fr)_minmax(0,1fr)] sm:grid-cols-[16px_minmax(0,2.3fr)_minmax(0,1.2fr)_minmax(0,1fr)_minmax(0,1.2fr)_minmax(0,1fr)] gap-3 items-center px-1 py-2.5 border-t border-[#F0F1F5] text-[10px]" data-id="element-6312" data-mp="r1cerzr6waa">
              <span className="w-3 h-3 rounded-[3px] border border-[#D5D8E0]" aria-hidden="true" data-id="element-6313" data-mp="5ol1kmxzoth0" />
              <span className="min-w-0" data-id="element-6314" data-mp="kdh6wc8nvsdx">
                <span className="block text-[#5B6478]" data-id="element-6315" data-mp="kgleljlc569c">{r.id}</span>
                <span className="block text-[#121212] truncate" data-id="element-6316" data-mp="fgqpnll4eqqx">{isFR ? r.title.fr : r.title.en}</span>
              </span>
              <span data-id="element-6317" data-mp="td48ay1e4y6z">
                <span className={r.status === 'resolved' ? 'inline-block rounded-md bg-[#E8F7EE] text-[#1F8A4C] px-2 py-0.5 text-[9.5px]' : 'inline-block rounded-md bg-[#EEF0FF] text-[#4F46E5] px-2 py-0.5 text-[9.5px] whitespace-nowrap'} data-id="element-6318" data-mp="og430pcd7zgx">
                  {isFR ? STATUS_LABEL[r.status].fr : STATUS_LABEL[r.status].en}
                </span>
              </span>
              <span className="flex items-center gap-1.5 text-[#121212]" data-id="element-6319" data-mp="29q88fzxg724b">
                <span className={`w-1.5 h-1.5 rounded-full ${r.high ? 'bg-[#E5484D]' : 'bg-[#22A55B]'}`} aria-hidden="true" data-id="element-6320" data-mp="1d3mtopbwb4hk" />
                {r.high ? t('Élevée', 'High') : t('Normale', 'Normal')}
              </span>
              <span className="hidden sm:block text-[#5B6478] truncate" data-id="element-6321" data-mp="1m0neklzrakg9">{isFR ? r.team.fr : r.team.en}</span>
              <span className="hidden sm:block text-[#7A8194] leading-tight" data-id="element-6322" data-mp="1qvb5ssm59syj">
                {r.update && <>
                    {(isFR ? r.update.fr : r.update.en)[0]}
                    <br data-id="element-6323" data-mp="yb2svvc7x93a" />
                    {(isFR ? r.update.fr : r.update.en)[1]}
                  </>}
              </span>
            </div>)}
        </div>
      </div>

      {/* Map */}
      <div className="relative mt-3 h-[190px] bg-[#F3F4F7] overflow-hidden" aria-hidden="true" data-id="element-6324" data-mp="gvgsjbzjxan6">
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 190" preserveAspectRatio="xMidYMid slice" data-id="element-6325" data-mp="ctvkc3xypkjb">
          <g stroke="#FFFFFF" strokeLinecap="round" fill="none" data-id="element-6326" data-mp="7uipavwxt75n">
            <path d="M-10 60 L620 20" strokeWidth="9" data-id="element-6327" data-mp="7wve9t144hs7" />
            <path d="M-10 150 L620 110" strokeWidth="6" data-id="element-6328" data-mp="330wiv52icvr" />
            <path d="M120 -10 L180 200" strokeWidth="7" data-id="element-6329" data-mp="3uad3yig5fbyh" />
            <path d="M300 -10 L260 200" strokeWidth="5" data-id="element-6330" data-mp="3uawlvz5su0ci" />
            <path d="M420 -10 L470 200" strokeWidth="6" data-id="element-6331" data-mp="3pbse9cyiwaoa" />
            <path d="M40 -10 L90 200" strokeWidth="3" data-id="element-6332" data-mp="3pd3e51oukya4" />
            <path d="M200 90 L380 70" strokeWidth="3" data-id="element-6333" data-mp="3l9ygpdjmjmsc" />
          </g>
          <g stroke="#E4E6EC" fill="none" strokeWidth="1" data-id="element-6334" data-mp="3galrwn9705n4">
            <path d="M0 100 L600 70" data-id="element-6335" data-mp="3gb3z2exe849t" />
            <path d="M230 -10 L200 200" data-id="element-6336" data-mp="ylxaav7hkmni" />
            <path d="M350 -10 L380 200" data-id="element-6337" data-mp="ykm82ztovmyi" />
          </g>
          <circle cx="215" cy="130" r="42" fill="#4F46E5" fillOpacity="0.06" stroke="#4F46E5" strokeOpacity="0.15" data-id="element-6338" data-mp="tmu437frsady" />
        </svg>
        <span className="absolute left-[6%] top-[25%] w-3.5 h-3.5 rounded-full bg-white border-[3px] border-[#4F46E5]" data-id="element-6339" data-mp="18c02wuap3ylb" />
        <span className="absolute left-[24%] top-[18%] w-4 h-4 rounded-full bg-[#F87171] border-[3px] border-white shadow" data-id="element-6340" data-mp="13dym6g0qsbd0" />
        <span className="absolute left-[14%] top-[62%] w-4 h-4 rounded-full bg-[#22A55B] border-[3px] border-white shadow" data-id="element-6341" data-mp="fp5ks41cpbb0" />
        <span className="absolute left-[34%] top-[60%] w-5 h-5 rounded-full bg-white border-[4px] border-[#4F46E5] shadow" data-id="element-6342" data-mp="pkz5iap84b3v" />
        <span className="absolute left-[39%] top-[32%] w-3 h-3 rounded-full bg-white border-[3px] border-[#4F46E5]" data-id="element-6343" data-mp="klw89cfhj96g" />

        <div className="absolute right-4 bottom-3 w-[190px] rounded-xl bg-white shadow-[0_12px_30px_-12px_rgba(18,18,18,0.25)] p-2" data-id="element-6344" data-mp="20z2vl5soxf3n">
          <img src={STREETLIGHT_IMG} alt="" className="w-full h-[74px] rounded-lg object-cover" data-id="element-6345" data-mp="1w3nl8ntw61bz" />
          <div className="flex items-center justify-between gap-2 px-1 pt-2" data-id="element-6346" data-mp="23n6mybax0j9w">
            <span className="min-w-0" data-id="element-6347" data-mp="28l860w8ccild">
              <span className="block font-sans text-[10px] font-semibold text-[#121212]" data-id="element-6348" data-mp="1ukf7m0ex53cz">
                {t('Lampadaire défectueux', 'Faulty streetlight')}
              </span>
              <span className="block font-sans text-[9px] text-[#7A8194] truncate" data-id="element-6349" data-mp="1ynkai42wv725">Rue des Érables, Brossard</span>
            </span>
            <ChevronRightIcon className="w-3.5 h-3.5 text-[#121212] shrink-0" data-id="element-6350" data-mp="2raxwx88zgk80" />
          </div>
        </div>
      </div>
    </div>;
}